function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { qs, qsAll } from "scripts/data_utils/domHelpers";

class PopupBase {
  constructor(el) {
    _defineProperty(this, "body", "Тут мог был быть ваш попап");

    this.el = el;
    this.bodySelector = qs("body");
    this.dialogBox = qs(".js-dialog-include");
    this.hidePopup = this.hidePopup.bind(this);
    this.showPopup = this.showPopup.bind(this);
    this.addHidePopupEventListener = this.addHidePopupEventListener.bind(this);
    this.hidePopupOnEsc = this.hidePopupOnEsc.bind(this);
  }

  hidePopup() {
    this.bodySelector.classList.remove("dialog-show");
    this.dialogBox.innerHTML = "";
    this.dialogBox.classList.remove("dialog-include--after-open");
    window.removeEventListener("keydown", this.hidePopupOnEsc);
  }

  showPopup() {
    this.bodySelector.classList.add("dialog-show");
    this.dialogBox.innerHTML = this.bodyTemplate();
    setTimeout(() => this.dialogBox.classList.add("dialog-include--after-open"), 1);
  }

  hidePopupOnEsc(e) {
    if (e.keyCode === 27) {
      this.hidePopup();
    }
  }

  addHidePopupEventListener() {
    window.addEventListener("keydown", this.hidePopupOnEsc);
    qsAll(".js-dialog-close").map(el => el.addEventListener("click", this.hidePopup));
  }

  bodyTemplate() {
    return `<div class="dialog-root" id="dialog-root">
    <div class="dialog-area js-dialog-close"></div>
    <div class="dialog">
      <div class="dialog-inner" id="dialog">
        <div class="modal-wrapper">
          ${this.body}
        </div>
      </div>
      <span class="dialog-close js-dialog-close"></span>
    </div>
  </div>`;
  }

  init() {
    this.showPopup();
    this.addHidePopupEventListener();
  }

}

export default PopupBase;